import React from "react";
import { serviceSteps } from "./serviceFeatureConstant";
import MarqueeCardScroller from "../../../Utility/MarqueeCardScroller";


const ServiceCardScroll: React.FC = () => {
  return <MarqueeCardScroller items={serviceSteps} />;
};

export default ServiceCardScroll;
